import React, { createContext, useContext, useState, useEffect } from 'react';
import { trackLanguageSelection } from '../utils/analytics';

const LanguageContext = createContext();

const translations = {
  en: {
    menu: 'Menu',
    reviews: 'Submit Review',
    pizza: 'Pizza',
    mainMenu: 'Main Menu',
    aquaFarina: 'Aqua Farina',
    reservation: 'Reservation',
    name: 'Name',
    date: 'Date',
    time: 'Time',
    persons: 'Number of Persons',
    enterName: 'Enter your name',
    enterEmailOrPhone: 'Enter email or phone number',
    emailOrPhone: 'Email or Phone',
    enterPhone: 'Enter phone number',
    phone: 'Phone',
    invalidPhone: 'Phone number must be 8 digits',
    invalidEmail: 'Please enter a valid email address',
    selectTime: 'Select time',
    submitReservation: 'Submit Reservation',
    reservationSuccess: 'Reservation Submitted!',
    reservationConfirmation: 'Your reservation has been received. We will contact you soon.',
    todoNotification: 'TODO: Send email and WhatsApp message to the customer',
    sendEmail: 'Send Email',
    sendWhatsApp: 'Send WhatsApp',
    newReservation: 'New Reservation',
    backToHome: 'Back to Home',
    when: 'When',
    howMany: 'How Many',
    where: 'Where',
    location: 'Location',
    indoor: 'Indoor (Non-Smoking)',
    terrace: 'Terrace',
    note: 'Note',
    notePlaceholder: 'Leave a note for the establishment',
    pax: 'P',
    finalizeReservation: 'Finalize Reservation',
    fillAllFields: 'Please fill all required fields',
    selectDate: 'Select Date',
    contactUs: 'Contact Us',
    getDirections: 'Get Directions',
    reserve: 'Reserve',
    call: 'Call',
    viewMenu: 'View Menu',
    days: ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'],
    months: ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER']
  },
  fr: {
    menu: 'Menu',
    reviews: 'Soumettre un avis',
    pizza: 'Pizza',
    mainMenu: 'Menu Principal',
    aquaFarina: 'Aqua Farina',
    reservation: 'Réservation',
    name: 'Nom',
    date: 'Date',
    time: 'Heure',
    persons: 'Nombre de personnes',
    enterName: 'Entrez votre nom',
    enterEmailOrPhone: 'Entrez votre email ou numéro de téléphone',
    emailOrPhone: 'Email ou Téléphone',
    enterPhone: 'Entrez votre numéro de téléphone',
    phone: 'Téléphone',
    invalidPhone: 'Le numéro de téléphone doit contenir 8 chiffres',
    invalidEmail: 'Veuillez entrer une adresse email valide',
    selectTime: 'Sélectionnez l\'heure',
    submitReservation: 'Soumettre la réservation',
    reservationSuccess: 'Réservation soumise !',
    reservationConfirmation: 'Votre réservation a été reçue. Nous vous contacterons bientôt.',
    todoNotification: 'À FAIRE : Envoyer un email et un message WhatsApp au client',
    sendEmail: 'Envoyer un email',
    sendWhatsApp: 'Envoyer un WhatsApp',
    newReservation: 'Nouvelle réservation',
    backToHome: 'Retour à l\'accueil',
    when: 'Quand',
    howMany: 'Combien',
    where: 'Où',
    location: 'Localisation',
    indoor: 'Salle Intérieure (Non Fumeur)',
    terrace: 'Terrasse',
    note: 'Note',
    notePlaceholder: 'Laisser une note pour l\'établissement',
    pax: 'P',
    finalizeReservation: 'Finaliser la réservation',
    fillAllFields: 'Veuillez remplir tous les champs requis',
    selectDate: 'Sélectionner une date',
    contactUs: 'Contactez-nous',
    getDirections: 'Naviguer au restaurant',
    reserve: 'Réserver',
    call: 'Appeler',
    viewMenu: 'Voir le menu',
    days: ['DIMANCHE', 'LUNDI', 'MARDI', 'MERCREDI', 'JEUDI', 'VENDREDI', 'SAMEDI'],
    months: ['JANVIER', 'FÉVRIER', 'MARS', 'AVRIL', 'MAI', 'JUIN', 'JUILLET', 'AOÛT', 'SEPTEMBRE', 'OCTOBRE', 'NOVEMBRE', 'DÉCEMBRE']
  },
  it: {
    menu: 'Menu',
    reviews: 'Invia recensione',
    pizza: 'Pizza',
    mainMenu: 'Menu Principale',
    aquaFarina: 'Aqua Farina',
    reservation: 'Prenotazione',
    name: 'Nome',
    date: 'Data',
    time: 'Ora',
    persons: 'Numero di persone',
    enterName: 'Inserisci il tuo nome',
    enterEmailOrPhone: 'Inserisci email o numero di telefono',
    emailOrPhone: 'Email o Telefono',
    enterPhone: 'Inserisci numero di telefono',
    phone: 'Telefono',
    invalidPhone: 'Il numero di telefono deve contenere 8 cifre',
    invalidEmail: 'Inserisci un indirizzo email valido',
    selectTime: 'Seleziona l\'ora',
    submitReservation: 'Invia prenotazione',
    reservationSuccess: 'Prenotazione inviata!',
    reservationConfirmation: 'La tua prenotazione è stata ricevuta. Ti contatteremo presto.',
    todoNotification: 'DA FARE: Invia email e messaggio WhatsApp al cliente',
    sendEmail: 'Invia email',
    sendWhatsApp: 'Invia WhatsApp',
    newReservation: 'Nuova prenotazione',
    backToHome: 'Torna alla home',
    when: 'Quando',
    howMany: 'Quanti',
    where: 'Dove',
    location: 'Posizione',
    indoor: 'Sala Interna (Non Fumatori)',
    terrace: 'Terrazza',
    note: 'Nota',
    notePlaceholder: 'Lascia una nota per il ristorante',
    pax: 'P',
    finalizeReservation: 'Finalizza prenotazione',
    fillAllFields: 'Si prega di compilare tutti i campi obbligatori',
    selectDate: 'Seleziona data',
    contactUs: 'Contattaci',
    getDirections: 'Ottieni indicazioni',
    reserve: 'Prenota',
    call: 'Chiama',
    viewMenu: 'Vedi menu',
    days: ['DOMENICA', 'LUNEDÌ', 'MARTEDÌ', 'MERCOLEDÌ', 'GIOVEDÌ', 'VENERDÌ', 'SABATO'],
    months: ['GENNAIO', 'FEBBRAIO', 'MARZO', 'APRILE', 'MAGGIO', 'GIUGNO', 'LUGLIO', 'AGOSTO', 'SETTEMBRE', 'OTTOBRE', 'NOVEMBRE', 'DICEMBRE']
  },
  ar: {
    menu: 'القائمة',
    reviews: 'إرسال تقييم',
    pizza: 'بيتزا',
    mainMenu: 'القائمة الرئيسية',
    aquaFarina: 'أكوا فارينا',
    reservation: 'حجز',
    name: 'الاسم',
    date: 'التاريخ',
    time: 'الوقت',
    persons: 'عدد الأشخاص',
    enterName: 'أدخل اسمك',
    enterEmailOrPhone: 'أدخل البريد الإلكتروني أو رقم الهاتف',
    emailOrPhone: 'البريد الإلكتروني أو الهاتف',
    enterPhone: 'أدخل رقم الهاتف',
    phone: 'الهاتف',
    invalidPhone: 'يجب أن يحتوي رقم الهاتف على 8 أرقام',
    invalidEmail: 'يرجى إدخال عنوان بريد إلكتروني صحيح',
    selectTime: 'اختر الوقت',
    submitReservation: 'إرسال الحجز',
    reservationSuccess: 'تم إرسال الحجز!',
    reservationConfirmation: 'تم استلام حجزك. سنتواصل معك قريباً.',
    todoNotification: 'مهام: إرسال بريد إلكتروني ورسالة واتساب للعميل',
    sendEmail: 'إرسال بريد إلكتروني',
    sendWhatsApp: 'إرسال واتساب',
    newReservation: 'حجز جديد',
    backToHome: 'العودة إلى الصفحة الرئيسية',
    when: 'متى',
    howMany: 'كم',
    where: 'أين',
    location: 'الموقع',
    indoor: 'قاعة داخلية (غير مدخنين)',
    terrace: 'تراس',
    note: 'ملاحظة',
    notePlaceholder: 'اترك ملاحظة للمؤسسة',
    pax: 'P',
    finalizeReservation: 'إتمام الحجز',
    fillAllFields: 'يرجى ملء جميع الحقول المطلوبة',
    selectDate: 'اختر التاريخ',
    contactUs: 'اتصل بنا',
    getDirections: 'الملاحة إلى المطعم',
    reserve: 'حجز',
    call: 'اتصال',
    viewMenu: 'عرض القائمة',
    days: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
    months: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('fr');

  useEffect(() => {
    // Détecter la langue du navigateur
    const browserLang = navigator.language || navigator.userLanguage;
    const langCode = browserLang.split('-')[0].toLowerCase();
    
    // Vérifier si la langue est supportée
    let initialLang = 'fr';
    if (['en', 'fr', 'it', 'ar'].includes(langCode)) {
      initialLang = langCode;
    }
    
    setLanguage(initialLang);
    // Tracker la langue initiale détectée automatiquement
    trackLanguageSelection(initialLang);
  }, []);

  const changeLanguage = (lang) => {
    if (['en', 'fr', 'it', 'ar'].includes(lang)) {
      setLanguage(lang);
      // Tracker le changement de langue manuel
      trackLanguageSelection(lang);
    }
  };

  const t = (key) => {
    return translations[language]?.[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
